import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import { IconComponent } from '../../../icon/icon.component';
import { RtAddNewButtonVariant } from '../../button.types';
import { BaseButtonDirective } from './../../base-button';

@Component({
  standalone: true,
  selector: 'rt-add-new-button, a[rt-add-new-button]',
  templateUrl: './add-new-button.component.html',
  styleUrls: ['./../../styles/base.less', './add-new-button.component.less'],
  // eslint-disable-next-line
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslatePipe, IconComponent],
})
export class AddNewButtonComponent extends BaseButtonDirective {
  @Input() public variant: RtAddNewButtonVariant = 'rounded';
  @Input() public text: string;
}
